import { Grid, makeStyles, Tooltip } from '@material-ui/core';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import { HealthGauge, UIText, useWithSound } from '@timeflies/app-ui';
import { CharacterUtils, switchUtil } from '@timeflies/common';
import { CharacterAnimatedImage } from '@timeflies/sprite-image';
import { SpritesheetsUtils } from '@timeflies/static-assets';
import React from 'react';
var height = 48;
var spriteSize = 32;
var teamRectWidth = 4;
var healthGaugeWidth = 8;
var width = teamRectWidth + height + healthGaugeWidth;
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            width: width
        },
        disconnectIcon: {
            width: 17,
            height: 17,
            verticalAlign: 'bottom'
        },
        content: function (_a) {
            var isPlaying = _a.isPlaying;
            return ({
                display: 'inline-flex',
                height: height,
                cursor: 'pointer',
                outlineColor: isPlaying ? palette.common.white : 'transparent',
                outlineWidth: 2,
                outlineStyle: 'solid',
            });
        },
        teamRect: function (_a) {
            var teamColor = _a.teamColor;
            return ({
                width: teamRectWidth,
                height: '100%',
                backgroundColor: teamColor
            });
        },
        spriteRect: function (_a) {
            var playerRelation = _a.playerRelation;
            return ({
                width: height,
                height: '100%',
                backgroundColor: switchUtil(playerRelation, {
                    me: palette.background.paper,
                    ally: palette.playerRelations.ally,
                    enemy: palette.playerRelations.enemy
                }),
                padding: (height - spriteSize) / 2
            });
        },
        disabled: function (_a) {
            var isAlive = _a.isAlive, isDisconnected = _a.isDisconnected;
            return ({
                opacity: (isAlive && !isDisconnected) ? 1 : 0.5
            });
        },
        healthGauge: {
            width: healthGaugeWidth,
            padding: 2,
            backgroundColor: palette.background.default
        },
        tooltipPopper: {
            zIndex: 0
        }
    });
});
export var CharacterItem = function (_a) {
    var playerName = _a.playerName, teamColor = _a.teamColor, playerRelation = _a.playerRelation, characterRole = _a.characterRole, health = _a.health, isAI = _a.isAI, isPlaying = _a.isPlaying, isDisconnected = _a.isDisconnected, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick;
    var isAlive = CharacterUtils.isAlive(health);
    var classes = useStyles({ teamColor: teamColor, playerRelation: playerRelation, isPlaying: isPlaying, isAlive: isAlive, isDisconnected: isDisconnected });
    var withSound = useWithSound('buttonClick');
    var state = {
        role: characterRole,
        state: 'idle',
        orientation: 'bottom'
    };
    var animationPath = SpritesheetsUtils.getCharacterAnimationPath(state);
    var framesDurations = SpritesheetsUtils.getCharacterFramesDurations(state);
    return React.createElement(Grid, { className: classes.root, container: true, direction: 'column' },
        React.createElement(Grid, { item: true },
            React.createElement(Tooltip, { classes: { popper: classes.tooltipPopper }, open: isAI, arrow: true, title: React.createElement(UIText, { variant: 'body2' }, "AI"), placement: "right" },
                React.createElement(UIText, { className: classes.disabled, variant: 'body2', noWrap: true },
                    playerName,
                    " ",
                    isDisconnected && (React.createElement(LinkOffIcon, { className: classes.disconnectIcon }))))),
        React.createElement(Grid, { item: true },
            React.createElement("div", { className: classes.content, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: withSound(onClick) },
                React.createElement("div", { className: classes.teamRect }),
                React.createElement("div", { className: classes.spriteRect },
                    React.createElement("div", { className: classes.disabled },
                        React.createElement(CharacterAnimatedImage, { size: spriteSize, animationPath: animationPath, framesDurations: framesDurations, pingPong: false, run: false, scale: 2 }))),
                React.createElement("div", { className: classes.healthGauge },
                    React.createElement(HealthGauge, { direction: 'vertical', health: health })))));
};
